(() => {
  'use strict';
  const root = document.querySelector('[data-fp-edit]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const el = name => root.querySelector(`[data-edit-${name}]`);
  const cards = [...root.querySelectorAll('[data-edit-product]')];
  const key = `fivepoint-edit-v1:${root.dataset.handle}:${root.dataset.page}:${root.dataset.country}:${root.dataset.currency}`;
  const money = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency });
  const eligible = card => /^\d+$/.test(card.dataset.variant || '') && /^\d+$/.test(card.dataset.price || '');
  const available = new Map(cards.filter(eligible).map(card => [card.dataset.variant, card]));
  let selected = new Set(), adding = false, uncertain = false;
  const status = message => { el('status').textContent = message; };
  function persist() {
    try { sessionStorage.setItem(key, JSON.stringify({ ids: [...selected], uncertain })); return true; }
    catch { status(window.FivePointI18n.t("Your selection could not be saved. Enable browser storage or order from the individual fabric pages.")); return false; }
  }
  function restore() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!saved) return;
      if (!Array.isArray(saved.ids) || saved.ids.length > 12 || saved.ids.some(id => typeof id !== 'string' || !/^\d+$/.test(id)) || typeof saved.uncertain !== 'boolean') throw new Error(window.FivePointI18n.t("Invalid selection"));
      selected = new Set(saved.ids.filter(id => available.has(id)));
      uncertain = saved.uncertain;
      if (selected.size !== saved.ids.length) status(window.FivePointI18n.t("Some colour cards are no longer available and were removed from your selection."));
      if (uncertain) status(window.FivePointI18n.t("The last bag update was not confirmed. Review your bag before starting a new selection."));
    } catch { status(window.FivePointI18n.t("Your saved selection could not be restored. Please select your colour cards again.")); }
  }
  function update() {
    let total = 0;
    const images = [];
    for (const card of cards) {
      const checked = selected.has(card.dataset.variant);
      card.querySelector('[data-edit-pick]').checked = checked;
      card.querySelector('[data-edit-pick]').disabled = !eligible(card) || adding || uncertain;
      card.classList.toggle('is-selected', checked);
      if (!checked) continue;
      total += Number(card.dataset.price);
      if (images.length < 4) {
        const source = card.querySelector('.fp-card__ph img');
        if (source) { const img = document.createElement('img'); img.src = source.currentSrc || source.src; img.alt = card.dataset.handle.toUpperCase(); images.push(img); }
      }
    }
    el('images').replaceChildren(...images);
    el('count').textContent = selected.size ? window.FivePointI18n.t("{{p0}} colour card{{p1}} selected", [selected.size, selected.size === 1 ? '' : 's']) : window.FivePointI18n.t("Choose your colour cards");
    el('total').textContent = selected.size ? money.format(total / 100) : '';
    el('clear').hidden = !selected.size && !uncertain;
    el('clear').disabled = adding;
    el('clear').textContent = uncertain ? window.FivePointI18n.t("Start a new selection") : window.FivePointI18n.t("Clear selection");
    el('add').disabled = adding || uncertain || !selected.size;
    el('add').textContent = adding ? window.FivePointI18n.t("Adding colour cards…") : window.FivePointI18n.t("Add selected colour cards to bag →");
    el('review').hidden = !uncertain || adding;
    const refine = root.querySelector('[data-fp-edit-refine]');
    refine.disabled = adding;
  }
  root.addEventListener('change', event => {
    if (!event.target.matches('[data-edit-pick]')) return;
    const card = event.target.closest('[data-edit-product]');
    if (!eligible(card) || adding || uncertain) { update(); return; }
    if (event.target.checked && selected.size >= 12) { status(window.FivePointI18n.t("Select up to 12 colour cards at a time.")); update(); return; }
    if (event.target.checked) selected.add(card.dataset.variant); else selected.delete(card.dataset.variant);
    status(''); persist(); update();
  });
  el('clear').addEventListener('click', () => { if (adding) return; selected.clear(); uncertain = false; status(''); persist(); update(); });
  el('review').addEventListener('click', async () => {
    const bag = document.getElementById('cart-drawer');
    if (typeof bag?.refreshAndOpen !== 'function') { status(window.FivePointI18n.t("The shopping bag has not loaded. Refresh this page to review it.")); return; }
    await bag.refreshAndOpen();
  });
  el('add').addEventListener('click', async () => {
    if (adding || uncertain || !selected.size) return;
    const bag = document.getElementById('cart-drawer');
    if (typeof bag?.addItems !== 'function') { status(window.FivePointI18n.t("The shopping bag has not loaded. Refresh before adding colour cards.")); return; }
    const items = [...selected].map(id => ({ id, quantity: 1 }));
    // Persist BEFORE the mutation so refresh/navigation after a lost response
    // cannot repeat it. Reconciliation is an explicit bag review, never a retry.
    uncertain = true;
    if (!persist()) { uncertain = false; return; }
    adding = true; status(''); update();
    try {
      await bag.addItems(items);
      selected.clear(); uncertain = false; persist(); status(window.FivePointI18n.t("Colour cards added to your bag."));
    } catch (error) {
      status(window.FivePointI18n.t("{{p0}} Review your bag before starting a new selection.", [error instanceof TypeError ? 'We could not confirm the bag update.' : error.message]));
    } finally { adding = false; update(); }
  });
  const refine = root.querySelector('[data-fp-edit-refine]');
  refine.hidden = !document.querySelector('[data-fp-assistant]');
  refine.addEventListener('click', () => {
    const handles = [...selected].map(id => available.get(id).dataset.handle.toUpperCase());
    const all = cards.map(card => card.dataset.handle.toUpperCase()).join(', ');
    const context = window.FivePointI18n.t("I'm exploring the \"{{p0}}\" fabric edit ({{p1}}).{{p2}} Help me refine this selection: ", [root.dataset.title, all, handles.length ? ` My selected colour cards are ${handles.join(', ')}.` : '']);
    document.dispatchEvent(new CustomEvent('fivepoint:assistant-compose', { detail: { text: context, trigger: refine } }));
  });
  restore(); update(); el('selection').hidden = false;
  new ResizeObserver(entries => {
    document.documentElement.style.setProperty('--fp-edit-bar-height', `${Math.ceil(entries[0].target.getBoundingClientRect().height)}px`);
  }).observe(el('selection'));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    selected = new Set(); uncertain = false; status(''); restore(); update();
  });
})();
